import { API_MAP, agent, functions } from 'helpers';

class ShowcaseService {
  static getProducer(limit: number, high: boolean, low: boolean) {
    let highParam = '';
    let lowParam = '';
    if (high) {
      highParam = '&high=true';
    }
    if (low) {
      lowParam = '&low=true';
    }
    return agent.get(API_MAP.listShowcaseProducer.replace('{limit}', limit.toString()) + highParam + lowParam);
  }
  static getAffiliate(limit: number, high: boolean, low: boolean) {
    let highParam = '';
    let lowParam = '';
    if (high) {
      highParam = '&high=true';
    }
    if (low) {
      lowParam = '&low=true';
    }
    return agent.get(API_MAP.listShowcaseAffiliate.replace('{limit}', limit.toString()) + highParam + lowParam);
  }

  static getFresh(limit: number) {
    return agent.get(API_MAP.listShowcaseFresh.replace('{limit}', limit.toString()));
  }

  static getBestsellers(limit: number) {
    return agent.get(API_MAP.listShowcaseBestsellers.replace('{limit}', limit.toString()));
  }

  static getGeneral(pagination: any, filters: any) {
    const filter = {
      price_initial:
        filters.startPrice && Number.parseFloat(functions.clearMoneyMask(filters.startPrice))
          ? functions.clearMoneyMask(filters.startPrice)
          : undefined,
      price_final:
        filters.endPrice && Number.parseFloat(functions.clearMoneyMask(filters.endPrice)) ? functions.clearMoneyMask(filters.endPrice) : undefined,
      commission_initial:
        filters.startCommission && Number.parseFloat(functions.clearMoneyMask(filters.startCommission))
          ? functions.clearMoneyMask(filters.startCommission)
          : undefined,
      commission_final:
        filters.endCommission && Number.parseFloat(functions.clearMoneyMask(filters.endCommission))
          ? functions.clearMoneyMask(filters.endCommission)
          : undefined,
      infinity_funnel: filters.infinityFunnel ? true : undefined,
      category: filters.category && filters.category !== 'not-selected' ? filters.category : undefined,
      orderby: filters.order && filters.order !== 'not-selected' ? filters.order : undefined,
      //title: filters.title ? filters.title : undefined,
      type: filters.type && filters.type !== 'not-selected' ? filters.type : undefined,
      title: filters.product_description ? filters.product_description : undefined,
      keyword: filters.keyword ? filters.keyword : undefined,
      ...pagination,
    };
    return agent.get(API_MAP.listShowcase, filter);
  }

  static getPhysical(type: string, limit: number) {
    return agent.get(API_MAP.listShowcasePhysical.replace('{type}', type.toString()).replace('{limit}', limit.toString()));
  }

  static listAdvertisementMaterial(productId: number) {
    return agent.get(API_MAP.listAdvertisementMaterial.replace('{id}', productId.toString()));
  }

  static listShowcaseQuestions(productId: number, perPage: number) {
    return agent.get(API_MAP.listShowcaseQuestions.replace('{id}', productId.toString()).replace('{per_page}', perPage.toString()));
  }

  static askQuestion(productId: number, question: any) {
    return agent.post(API_MAP.askQuestion.replace('{id}', productId.toString()), question);
  }

  static createAffiliate(productId: number, message: any) {
    return agent.post(API_MAP.createAffiliate.replace('{id}', productId.toString()), message);
  }

  static allRatingsShowcase(productId: number) {
    return agent.get(API_MAP.allRatingsShowcase.replace('{id}', productId.toString()));
  }

  static ratingShowcase(productId: number, quantity: number) {
    return agent.get(API_MAP.ratingShowcase.replace('{id}', productId.toString()).replace('{per_page}', quantity.toString()));
  }

  static showcaseProfile(producerId: number) {
    return agent.get(API_MAP.showcaseProfile.replace('{id}', producerId.toString()));
  }

  static rateProducer(producerId: any, rating: any) {
    return agent.post(API_MAP.rateProducer.replace('{id}', producerId.toString()), rating);
  }

  static getSubscriptions(limit: number) {
    return agent.get(API_MAP.getSubscriptionsShowcase.replace('{limit}', limit.toString()));
  }
}
export default ShowcaseService;
